/* eslint-disable handle-callback-err */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import PropTypes from "prop-types";
export default class Policies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptedPolicies: this.props.acceptedPolicies || false,
      policyLink: "",
    };
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/login/getPolicyLink`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({ policyLink: res });
      })
      .catch((err) => this.setState({ policyLink: "#" }));
  }

  render() {
    return (
      <div>
        <p style={{ fontWeight: "normal", fontSize: 14 }}>
          o This application is valid for one semester only.
        </p>
        <p style={{ fontWeight: "normal", fontSize: 14 }}>
          o This application is valid for the selected program.
        </p>
        <p style={{ fontWeight: "normal", fontSize: 14 }}>
          o Any health-related issues will only be regarded as health-based
          information and will not affect your acceptance to the university.
        </p>
        <p style={{ fontWeight: "normal", fontSize: 14 }}>
          o The application fee is not refundable.
        </p>
        <p style={{ fontWeight: "normal", fontSize: 14 }}>
          o Decisions are taken by ESLSCA University in good faith on the basis
          of statements made in a student's application for admission. If it is
          discovered that a false statement has been made or significant
          information has been omitted from a student's application form, the
          school may withdraw or amend its offer or terminate the student's
          registration at ESLSCA University, according to circumstances.
        </p>

        <p>
          <input
            type="checkbox"
            value={this.state.acceptedPolicies}
            onChange={() => {
              this.props.collectState("Policies", !this.state.acceptedPolicies);
              this.setState((prevState) => ({
                acceptedPolicies: !prevState.acceptedPolicies,
              }));
            }}
            checked={this.state.acceptedPolicies}
          />{" "}
          Accept Policies
        </p>
      </div>
    );
  }
}
Policies.propTypes = {
  collectState: PropTypes.func.isRequired,
  acceptedPolicies: PropTypes.bool,
};
